<button
  class="change"
  (click)="onButtonClick()"
>
  <i class="change__icon"></i><span class="change__txt">本を変更する</span>
</button>
